import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { AirtimePlanDetailView } from "./component";
import { Product } from "../../../../components/Reusable/type";
import { fetchAirtimePlans } from "../../../../features/auth/store/airtimePlanSlice";
import { AppDispatch, RootState } from "../../../../redux/store";
import AirtimePlans from "./Airtime";

const AirtimePlanRouter: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [statusFilter, setStatusFilter] = useState<string>("");
  const [selectedAirtimePlan, setSelectedAirtimePlan] =
    useState<Product | null>(null);
  const [showDetailView, setShowDetailView] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>("");

  const { airtimePlans, loading, error } = useSelector(
    (state: RootState) => state.airtimePlans
  );

  useEffect(() => {
    const filters: any = {};

    // Only add status filter if it's not empty
    if (statusFilter && statusFilter !== "") {
      filters.status = statusFilter;
    }
    if (searchTerm && searchTerm !== "") {
      filters.search = searchTerm;
    }

    dispatch(fetchAirtimePlans(filters));
  }, [dispatch, statusFilter, searchTerm]);

  // Transform DataPlan to Product - ensuring all required fields are present

  const handleAirtimePlanClick = (airtimePlan: Product) => {
    setSelectedAirtimePlan(airtimePlan);
    setShowDetailView(true);
  };

  const handleBackToList = () => {
    setShowDetailView(false);
    setSelectedAirtimePlan(null);
  };

  if (showDetailView && selectedAirtimePlan) {
    return (
      <AirtimePlanDetailView
        airtimePlan={{
          ...selectedAirtimePlan,
        }}
        onBack={handleBackToList}
      />
    );
  }

  return (
    <AirtimePlans
      airtimePlans={airtimePlans || []}
      loading={loading}
      error={error}
      statusFilter={statusFilter}
      setStatusFilter={setStatusFilter}
      onAirtimePlanClick={handleAirtimePlanClick}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
    />
  );
};

export default AirtimePlanRouter;
